export const TAB_IDS = {
  DETAILS: 'details',
  DISCUSSION: 'discussion',
  ATTACHMENTS: 'attachments',
  CONTRIBUTORS: 'contributors',
} as const;

export type TabId = (typeof TAB_IDS)[keyof typeof TAB_IDS];

export const TAB_ID_TO_INDEX: Record<TabId, number> = {
  [TAB_IDS.CONTRIBUTORS]: 0,
  [TAB_IDS.DETAILS]: 1,
  [TAB_IDS.DISCUSSION]: 2,
  [TAB_IDS.ATTACHMENTS]: 3,
};

export const INDEX_TO_TAB_ID: Record<number, TabId> = {
  0: TAB_IDS.CONTRIBUTORS,
  1: TAB_IDS.DETAILS,
  2: TAB_IDS.DISCUSSION,
  3: TAB_IDS.ATTACHMENTS,
};
